import React, { useEffect, useState } from 'react';
import { Card } from '@uhg-abyss/web/ui/Card';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Box } from '@uhg-abyss/web/ui/Box';
import { Text } from '@uhg-abyss/web/ui/Text';
import { Divider } from '@uhg-abyss/web/ui/Divider';

import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { RadioGroup } from '@uhg-abyss/web/ui/RadioGroup';
import { FormProvider } from '@uhg-abyss/web/ui/FormProvider';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { Button } from '@uhg-abyss/web/ui/Button';
import { TextInputArea } from '@uhg-abyss/web/ui/TextInputArea';
import {
  useLazyGetAnnouncementQuery,
  useLazyUpdateAnnouncementQuery,
} from '@src/store/services/LoginServices';
import { useDispatch } from 'react-redux';
import { toggle } from '@src/store/slices/ListofValuesSlice';

const Announcement = () => {
  const [data, setData] = useState([]);
  const [getAnnoucement] = useLazyGetAnnouncementQuery();
  const [updateAnnoucement] = useLazyUpdateAnnouncementQuery();
  const dispatch = useDispatch();

  const [errors, setErrors] = useState([]);

  const cardCssStyles = {
    'abyss-card-root': {
      width: '80%',
      margin: '10px auto',
    },
  };
  useEffect(() => {
    const fetchAnnouncement = async () => {
      const response = await getAnnoucement();
      if (response?.isSuccess) {
        setData(response?.data);
      }
    };
    fetchAnnouncement();
  }, []);

  const handleSubmit = async () => {
    const payload = {
      anncId: form.getValues('anncId'),
      anncTxt: form.getValues('anncTxt'),
      anncStsCd: form.getValues('anncStsCd'),
    };
    const validate = () => {
      const newErrors: string[] = [];

      if (
        form.getValues('anncTxt') === '' ||
        form.getValues('anncTxt') === null ||
        form.getValues('anncTxt') === undefined
      ) {
        newErrors.push('Please Provide Annoucement Message');
      }

      setErrors(newErrors);
      return newErrors?.length === 0;
    };
    if (validate()) {
      const response = await updateAnnoucement(payload);
      if (response?.isSuccess) {
        setData(response?.data);
        dispatch(toggle());
      }
    }
  };

  const form = useForm({
    defaultValues: {
      data,
    },
  });
  useEffect(() => {
    if (data && Object.keys(data).length) form.reset(data);
  }, [data]);

  const handleReset = () => {
    form.reset(data);
  };
  return (
    <FormProvider state={form}>
      <Grid>
        <Grid.Col
          css={{
            width: '100%',
            height: '50vh',
          }}
        >
          <Card css={cardCssStyles}>
            <div
              style={{
                backgroundColor:
                  'var(--abyss-colors-web-semantic-color-surface-container-primary)',
                color:
                  'var(--abyss-colors-web-semantic-color-text-content-primaryAlt)',
                paddingTop: '5px',
                paddingBottom: '5px',
                paddingLeft: '24px',
                paddingRight: '24px',
                borderTopLeftRadius: '3px',
                borderTopRightRadius: '3px',
                fontSize: '18px',
                fontWeight: 'bold',
              }}
            >
              Announcement Page
            </div>
            <Layout.Stack
              css={{ gap: '10px', width: '100%', minHeight: '37vh' }}
              grow
            >
              {errors?.length > 0 && (
                <Box
                  align="center"
                  color="transparent"
                  padding={0}
                  css={{ 'abyss-box-root': { color: 'red' } }}
                >
                  <ul>
                    {errors.map((error, index) => (
                      <li key={index}>{error}</li>
                    ))}
                  </ul>
                </Box>
              )}
              <Layout.Group alignLayout="center">
                {data && (
                  <Table.Container title="">
                    <Table.Row>
                      <Table.Cell css={{ width: '250px' }}>
                        <strong>Announcement Data</strong>
                      </Table.Cell>
                      <Table.Cell css={{ width: '500px' }}>
                        <TextInputArea
                          label=""
                          model="anncTxt"
                          css={{
                            '.abyss-text-input-area': { minHeight: '120px' },
                          }}
                          maxLength={1500}
                        />
                      </Table.Cell>
                    </Table.Row>

                    <Table.Row>
                      <Table.Cell>
                        <strong>Announcement Status</strong>
                      </Table.Cell>
                      <Table.Cell>
                        <RadioGroup label="" model="anncStsCd">
                          <RadioGroup.Column>
                            <RadioGroup.Radio label="Active" value="AC" />
                            <RadioGroup.Radio label="De-Active" value="DC" />
                          </RadioGroup.Column>
                        </RadioGroup>
                      </Table.Cell>
                    </Table.Row>
                  </Table.Container>
                )}
              </Layout.Group>
            </Layout.Stack>

            <Layout.Group alignLayout="center" css={{ marginTop: '5px' }}>
              <Button onClick={handleReset}>Reset</Button>
              <Button onClick={handleSubmit}>Submit</Button>
            </Layout.Group>
            <Grid.Col css={{ width: '100%', textAlign: 'center' }}>
              <Box
                color="$web.semantic.color.surface.container.primary"
                padding={0}
                width="100%"
                height="20px"
                align="center"
              >
                <Text
                  asElement="label"
                  color="$web.semantic.color.text.content.primary-alt"
                  css={{ fontSize: '14px', fontWeight: 'bold' }}
                >
                  UPDATED ON {`${form.getValues('anncDate')}`} BY{' '}
                  {`${
                    form.getValues('updtUser')
                      ? form.getValues('updtUser')
                      : '-'
                  }`}
                </Text>
              </Box>
              <Divider orientation="horizontal" />
            </Grid.Col>
          </Card>
        </Grid.Col>
      </Grid>
    </FormProvider>
  );
};

export default Announcement;
